import { StatusBadge } from "@/components/app/common";
import { fmtDate, inr } from "@/lib/format";

const place = (r) => [r.dispatch_address_snapshot?.address_label, r.dispatch_address_snapshot?.city].filter(Boolean).join(" · ");

export const INV_COLS = [
  { key: "invoice_no", label: "Invoice", render: (r) => <span className="font-mono font-semibold text-sky-800">{r.invoice_no}</span> },
  { key: "invoice_date", label: "Date", render: (r) => fmtDate(r.invoice_date) },
  { key: "order_no", label: "LM", mono: true },
  { key: "customer", label: "Customer", wrap: true, value: (r) => r.customer?.name, render: (r) => r.customer?.name },
  { key: "address", label: "Deliver to", wrap: true, value: place, render: place },
  { key: "basic", label: "Basic value", value: (r) => r.totals.basic, render: (r) => <span className="font-mono">{inr(r.totals.basic)}</span> },
  { key: "total", label: "Total incl. GST", value: (r) => r.totals.total, render: (r) => <span className="font-mono">{inr(r.totals.total)}</span> },
  { key: "shipments", label: "Shipments" },
  { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} testid={`invoice-status-${r.invoice_no}`} /> },
];
